import { createHazardScoreBadge } from '../ScoreBadge'

const waterRiskLabels: Record<number, string> = {
  1: 'Low',
  2: 'Low-Medium',
  3: 'Medium-High',
  4: 'High',
  5: 'Extremely High',
}

// const waterRiskPalette = {
//   1: '#ffffa6',
//   2: '#fbe74d',
//   3: '#f19e38',
//   4: '#ea3b24',
//   5: '#8c1911',
// }

export function mapWaterRiskScore(value: number | null | undefined): number | null {
  if (typeof value !== 'number' || Number.isNaN(value)) return null
  const bounded = Math.min(Math.max(Math.round(value), 0), 4)
  return bounded + 1
}

export const WaterRiskScoreBadge = createHazardScoreBadge({
  labels: waterRiskLabels,
  // palette: waterRiskPalette,
  mapScore: mapWaterRiskScore,
})
